import React from 'react'
// libs
import { useSelector } from 'react-redux'
// components
import Grid from '@mui/material/Grid2'
import Switch from '@mui/material/Switch'
// constants
import { Forms } from 'constants/index'
import { LICENCES_NAMES } from 'constants/licences'
// view
import { LicencePaper, SetLicences, Share, Title } from './views'
// utils
import get from 'lodash/get'

interface Props {
  licence: { name: string; type: keyof typeof LICENCES_NAMES }
  handleSetClick: ({ name, key }: { name: string; key: keyof typeof LICENCES_NAMES }) => any
  handleSwitchToggle: ({ name, key }: { name: string; key: keyof typeof LICENCES_NAMES }) => any
}

const Licence: React.FC<Props> = ({ licence, handleSetClick, handleSwitchToggle }) => {
  const { accountForm } = useSelector((state: any) => ({
    accountForm: state.accumulatedForms[Forms.ACCUMULATED_CREATE_ACCOUNT]
  }))

  return (
    <LicencePaper>
      <Grid container spacing={1} justifyContent='space-between'>
        <Grid container justifyContent='space-between' alignItems='center' >
          <Grid>
            <Title>{licence.name}</Title>
          </Grid>
          <Grid>
            <Switch
              color='primary'
              value={licence.type}
              checked={get(accountForm, `licences[${licence.type as string}].active`, false)}
              onChange={handleSwitchToggle({ name: `${licence.name}`, key: licence.type })}
            />
          </Grid>
        </Grid>
        <Grid container alignItems='center'>
          <SetLicences onClick={handleSetClick({ name: `${licence.name}`, key: licence.type })}>
            Set Licences
          </SetLicences>
          <Share onClick={handleSetClick({ name: `${licence.name}`, key: licence.type })} />
        </Grid>
      </Grid>
    </LicencePaper>
  )
}

export default Licence
